// src/pages/ChangePasswordPage.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ChangePasswordPage() {
  const { authFetch, refreshUser } = useAuth();
  const navigate = useNavigate();

  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");

  const safeJson = async (res) => {
    try {
      const text = await res.text();
      if (!text) return null;
      try {
        return JSON.parse(text);
      } catch {
        return { error: text };
      }
    } catch {
      return null;
    }
  };

  const submit = async (e) => {
    e.preventDefault();
    setMsg("");
    setErr("");

    if (!oldPassword || !newPassword || !confirmPassword) {
      setErr("Please enter current password, new password, and confirm password.");
      return;
    }

    if (newPassword !== confirmPassword) {
      setErr("New password and confirm password do not match.");
      return;
    }

    setLoading(true);
    try {
      const res = await authFetch("/api/auth/change-password", {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ oldPassword, newPassword }),
      });

      const data = await safeJson(res);

      if (!res.ok) {
        setErr(data?.error || "Failed to change password.");
        setLoading(false);
        return;
      }

      setMsg("✔ Password successfully updated.");

      setOldPassword("");
      setNewPassword("");
      setConfirmPassword("");

      const fresh = await refreshUser();

      const role = String(fresh?.role || "").toLowerCase();
      const isAdmin =
        role === "superadmin" ||
        role === "manager" ||
        role === "ops_supervisor" ||
        role === "lead";

      setTimeout(() => {
        navigate(isAdmin ? "/admin/dashboard" : "/my-schedule", { replace: true });
      }, 800);
    } catch {
      setErr("Network error. Is backend running?");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#f4f6fb",
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        paddingTop: 60,
      }}
    >
      <div
        style={{
          width: 520,
          background: "#ffffff",
          borderRadius: 10,
          padding: 30,
          boxShadow: "0 8px 30px rgba(0,0,0,0.08)",
        }}
      >
        <h2 style={{ marginTop: 0 }}>🔐 Change Password</h2>

        <p style={{ color: "#666", fontSize: 14, marginBottom: 6 }}>
          Update your password below.
        </p>

        <form onSubmit={submit} style={{ display: "grid", gap: 14, marginTop: 20 }}>
          <label style={{ display: "grid", gap: 6 }}>
            <span style={{ fontWeight: 600 }}>Current Password</span>
            <input
              type="password"
              value={oldPassword}
              onChange={(e) => setOldPassword(e.target.value)}
              placeholder="Enter current password"
              style={{
                padding: 12,
                borderRadius: 6,
                border: "1px solid #d9d9d9",
                fontSize: 14,
              }}
            />
          </label>

          <label style={{ display: "grid", gap: 6 }}>
            <span style={{ fontWeight: 600 }}>New Password</span>
            <input
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              placeholder="Enter new password"
              style={{
                padding: 12,
                borderRadius: 6,
                border: "1px solid #d9d9d9",
                fontSize: 14,
              }}
            />
          </label>

          <label style={{ display: "grid", gap: 6 }}>
            <span style={{ fontWeight: 600 }}>Confirm Password</span>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="Re-enter new password"
              style={{
                padding: 12,
                borderRadius: 6,
                border: "1px solid #d9d9d9",
                fontSize: 14,
              }}
            />
          </label>

          {err && (
            <div
              style={{
                background: "#fff0f0",
                border: "1px solid #ffbaba",
                color: "#b00020",
                padding: 10,
                borderRadius: 6,
              }}
            >
              {err}
            </div>
          )}

          {msg && (
            <div
              style={{
                background: "#f0fff4",
                border: "1px solid #a6e6b3",
                color: "#0f7a33",
                padding: 10,
                borderRadius: 6,
              }}
            >
              {msg}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            style={{
              padding: 12,
              borderRadius: 6,
              border: "none",
              background: "#2563eb",
              color: "white",
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            {loading ? "Saving..." : "Update Password"}
          </button>

          <button
            type="button"
            onClick={() => navigate(-1)}
            style={{
              padding: 10,
              borderRadius: 6,
              border: "1px solid #ccc",
              background: "#f5f5f5",
              cursor: "pointer",
            }}
          >
            Back
          </button>
        </form>
      </div>
    </div>
  );
}